import {useQuery, useQueryClient} from "react-query";
import * as api from "../api/easeedesk/apis";

const getComments = async (ticketId, options) => {
    const {response, error} = await api.fetchTicketComments(ticketId, options);

    return response ? response.data.data : response;
};

export default function useTicketComments(ticketId, options) {
    return useQuery(['ticket_comments', {ticketId, options}], () => getComments(ticketId, options), {refetchOnWindowFocus: false});
}
